










import { Component, Mixins, Prop } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Types
import { IClient } from "@/models/clients";
import { IContract, IContractProduct } from "@/models/contracts";
import { ClientRoutes } from "@/data/enums/router";

@Component
export default class UContractProductLink extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public productId!: IContractProduct["id"];

  @Prop({ default: () => null })
  public clientId?: IClient["id"];

  @Prop({ default: () => null })
  public contractId?: IContract["id"];

  @Prop({ default: null })
  public to!: string;

  // Computed

  public get link() {
    if (this.to) return this.createRouterLink(this.to);
    if (this.isMockClientContext)
      return this.createRouterLink("admin__upmindClientCProd");
    if (this.isClient)
      return this.createRouterLink(ClientRoutes.CONTRACT_PRODUCT);
    return this.createRouterLink("admin__clientCProd");
  }

  // Methods

  public createRouterLink(routeName: string) {
    return {
      type: "router-link",
      props: {
        to: {
          name: routeName,
          params: {
            clientId: this.clientId,
            contractId: this.contractId,
            productId: this.productId
          }
        }
      }
    };
  }
}
